import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CentredWrapper, SmartBanner } from '@/components';
export const Unsupported = () => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(SmartBanner, {}), _jsxs(CentredWrapper, Object.assign({ maxW: '340px', textAlign: 'center' }, { children: [_jsx(Heading, Object.assign({ fontSize: '2xl', mb: '6' }, { children: t('app:components.study_unsupported.title') })), _jsx(Text, { children: t('app:components.study_unsupported.subtitle') })] }))] }));
};
